import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  query,
  orderBy,
} from "firebase/firestore";

function Tournaments() {
  const [data, setData] = useState([]);

  useEffect(() => {
    load();
  }, []);

  const collections = [
    "cs_tournaments",
    "lw_tournaments",
    "br_tournaments",
    "br_s_tournaments",
    "onetap_tournaments",
  ];

  const load = async () => {
    try {
      let all = [];

      for (let col of collections) {
        const q = query(
          collection(db, col),
          orderBy("time", "desc")
        );

        const snap = await getDocs(q);

        const temp = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
          type: col,
        }));

        all = [...all, ...temp];
      }

      all.sort(
        (a, b) =>
          (b.time?.seconds || 0) -
          (a.time?.seconds || 0)
      );

      setData(all);

    } catch (e) {
      console.error("Tournament load error:", e);
    }
  };

  return (
    <div style={container}>
      <h1 style={title}>🎮 Tournaments</h1>

      {data.length === 0 ? (
        <p style={{ opacity: 0.6 }}>No tournaments</p>
      ) : (
        <div style={grid}>
          {data.map((t) => {
            const players =
              t.joinedPlayers || t.participantsCount || 0;

            return (
              <div key={t.id} style={card}>
                
                {/* HEADER */}
                <div style={header}>
                  <span style={mode}>
                    {t.mode || "Match"}
                  </span>

                  <span style={badge(t.status)}>
                    {t.status || "upcoming"}
                  </span>
                </div>

                {/* BODY */}
                <h3 style={titleText}>
                  {t.title || "Tournament"}
                </h3>

                <p style={info}>
                  📍 {t.map || "Unknown"}
                </p>

                <p style={info}>
                  👥 {players}/{t.totalSpots || 0}
                </p>

                <p style={time}>
                  ⏰{" "}
                  {t.time?.seconds
                    ? new Date(
                        t.time.seconds * 1000
                      ).toLocaleString()
                    : "Coming Soon"}
                </p>

                {/* FOOTER */}
                <div style={footer}>
                  <span>₹{t.entryFee || 0}</span>
                  <span>🏆 ₹{t.prizePool || 0}</span>
                </div>

                {/* TYPE */}
                <p style={type}>{t.type}</p>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  padding: 20,
  color: "white",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
  minHeight: "100vh",
};

const title = {
  marginBottom: 20,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
  gap: 20,
};

const card = {
  background: "#1A1F2E",
  padding: 16,
  borderRadius: 12,
  border: "1px solid rgba(255,255,255,0.05)",
  transition: "0.25s",
  cursor: "pointer",
};

const header = {
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 10,
};

const mode = {
  fontSize: 13,
  opacity: 0.7,
};

const titleText = {
  marginBottom: 6,
};

const info = {
  fontSize: 13,
  opacity: 0.8,
};

const time = {
  fontSize: 12,
  opacity: 0.5,
  marginBottom: 10,
};

const footer = {
  display: "flex",
  justifyContent: "space-between",
  marginTop: 10,
  fontWeight: "bold",
};

const type = {
  fontSize: 11,
  opacity: 0.4,
  marginTop: 8,
};

const badge = (status) => ({
  padding: "4px 10px",
  borderRadius: 8,
  fontSize: 11,
  background:
    status === "completed"
      ? "#16a34a"
      : status === "cancelled"
      ? "#dc2626"
      : "#f59e0b",
  color: "#fff",
});

export default Tournaments;